import type { ReactNode } from 'react';
import type { PathRouteProps } from 'react-router';

export interface MtRouteProps extends PathRouteProps {
  // eslint-disable-next-line react/require-default-props
  buyer?: ReactNode;
  // eslint-disable-next-line react/require-default-props
  breeder?: ReactNode;
}
